// GeoJson
export const GET_LOCATION_GEOJSON_REQUEST = 'GET_LOCATION_GEOJSON_REQUEST';
export const GET_LOCATION_GEOJSON_ERROR = 'GET_LOCATION_GEOJSON_ERROR';
export const GET_LOCATION_GEOJSON_SUCCESS = 'GET_LOCATION_GEOJSON_SUCCESS';

// All base map
export const GET_ALL_BASE_MAP_REQUEST = 'GET_ALL_BASE_MAP_REQUEST';
export const GET_ALL_BASE_MAP_ERROR = 'GET_ALL_BASE_MAP_ERROR';
export const GET_ALL_BASE_MAP_SUCCESS = 'GET_ALL_BASE_MAP_SUCCESS';

// Images
export const GET_LOCATION_ASSETS_REQUEST = 'GET_LOCATION_ASSETS_REQUEST';
export const GET_LOCATION_ASSETS_ERROR = 'GET_LOCATION_ASSETS_ERROR';
export const GET_LOCATION_ASSETS_SUCCESS = 'GET_LOCATION_ASSETS_SUCCESS';

// Buildings
export const GET_BUILDINGS_REQUEST = 'GET_BUILDINGS_REQUEST';
export const GET_BUILDINGS_ERROR = 'GET_BUILDINGS_ERROR';
export const GET_BUILDINGS_SUCCESS = 'GET_BUILDINGS_SUCCESS';

// location Building Floor
export const GET_LOCATION_BUILDING_FLOORS_REQUEST = 'GET_LOCATION_BUILDING_FLOORS_REQUEST';
export const GET_LOCATION_BUILDING_FLOORS_ERROR = 'GET_LOCATION_BUILDING_FLOORS_ERROR';
export const GET_LOCATION_BUILDING_FLOORS_SUCCESS = 'GET_LOCATION_BUILDING_FLOORS_SUCCESS';

// Locations
export const GET_LOCATIONS_REQUEST = 'GET_LOCATIONS_REQUEST';
export const GET_LOCATIONS_ERROR = 'GET_LOCATIONS_ERROR';
export const GET_LOCATIONS_SUCCESS = 'GET_LOCATIONS_SUCCESS';
export const GET_LOCATIONS_BY_TYPE_REQUEST = 'GET_LOCATIONS_BY_TYPE_REQUEST';
export const GET_LOCATIONS_BY_TYPE_ERROR = 'GET_LOCATIONS_BY_TYPE_ERROR';
export const GET_LOCATIONS_BY_TYPE_SUCCESS = 'GET_LOCATIONS_BY_TYPE_SUCCESS';
export const GET_LOCATIONS_POINT_OF_INTEREST_TYPES_REQUEST = 'GET_LOCATIONS_POINT_OF_INTEREST_TYPES_REQUEST';
export const GET_LOCATIONS_POINT_OF_INTEREST_TYPES_ERROR = 'GET_LOCATIONS_POINT_OF_INTEREST_TYPES_ERROR';
export const GET_LOCATIONS_POINT_OF_INTEREST_TYPES_SUCCESS = 'GET_LOCATIONS_POINT_OF_INTEREST_TYPES_SUCCESS';
export const RESET_LOCATIONS_META = 'RESET_LOCATIONS_META';
export const RESET_LOCATIONS_PAGE = 'RESET_LOCATIONS_PAGE';

// Location Details
export const GET_LOCATION_DETAIL_REQUEST = 'GET_LOCATION_DETAIL_REQUEST';
export const GET_LOCATION_DETAIL_ERROR = 'GET_LOCATION_DETAIL_ERROR';
export const GET_LOCATION_DETAIL_SUCCESS = 'GET_LOCATION_DETAIL_SUCCESS';
export const RESET_LOCATION_DETAIL_META = 'RESET_LOCATION_DETAIL_META';
export const RESET_LOCATION_DETAIL_PAGE = 'RESET_LOCATION_DETAIL_PAGE';

// Point of interest
export const GET_POINT_OF_INTERESTS_REQUEST = 'GET_POINT_OF_INTERESTS_REQUEST';
export const GET_POINT_OF_INTERESTS_ERROR = 'GET_POINT_OF_INTERESTS_ERROR';
export const GET_POINT_OF_INTERESTS_SUCCESS = 'GET_POINT_OF_INTERESTS_SUCCESS';

// Panorama Nodes
export const GET_PANORAMA_NODES_REQUEST = 'GET_PANORAMA_NODES_REQUEST';
export const GET_PANORAMA_NODES_ERROR = 'GET_PANORAMA_NODES_ERROR';
export const GET_PANORAMA_NODES_SUCCESS = 'GET_PANORAMA_NODES_SUCCESS';

// Panorama Node by ID
export const GET_PANORAMA_NODE_BY_ID_REQUEST = 'GET_PANORAMA_NODE_BY_ID_REQUEST';
export const GET_PANORAMA_NODE_BY_ID_ERROR = 'GET_PANORAMA_NODE_BY_ID_ERROR';
export const GET_PANORAMA_NODE_BY_ID_SUCCESS = 'GET_PANORAMA_NODE_BY_ID_SUCCESS';

// Panorama Edges
export const GET_PANORAMA_EDGES_REQUEST = 'GET_PANORAMA_EDGES_REQUEST';
export const GET_PANORAMA_EDGES_ERROR = 'GET_PANORAMA_EDGES_ERROR';
export const GET_PANORAMA_EDGES_SUCCESS = 'GET_PANORAMA_EDGES_SUCCESS';

// Get Location ID by Remote ID
export const GET_LOCATION_ID_BY_REMOTE_ID_REQUEST = 'GET_LOCATION_ID_BY_REMOTE_ID_REQUEST';
export const GET_LOCATION_ID_BY_REMOTE_ID_ERROR = 'GET_LOCATION_ID_BY_REMOTE_ID_ERROR';
export const GET_LOCATION_ID_BY_REMOTE_ID_SUCCESS = 'GET_LOCATION_ID_BY_REMOTE_ID_SUCCESS';

// Directions
export const GET_DIRECTIONS_REQUEST = 'GET_DIRECTIONS_REQUEST';
export const GET_DIRECTIONS_ERROR = 'GET_DIRECTIONS_ERROR';
export const GET_DIRECTIONS_SUCCESS = 'GET_DIRECTIONS_SUCCESS';
export const GET_DIRECTIONS_LOCATIONS_REQUEST = 'GET_DIRECTIONS_LOCATIONS_REQUEST';
export const GET_DIRECTIONS_LOCATIONS_ERROR = 'GET_DIRECTIONS_LOCATIONS_ERROR';
export const GET_DIRECTIONS_LOCATIONS_SUCCESS = 'GET_DIRECTIONS_LOCATIONS_SUCCESS';

export const GET_NEAREST_LOCATION_REQUEST = 'GET_NEAREST_LOCATION_REQUEST';
export const GET_NEAREST_LOCATION_ERROR = 'GET_NEAREST_LOCATION_ERROR';
export const GET_NEAREST_LOCATION_SUCCESS = 'GET_NEAREST_LOCATION_SUCCESS';

export const RESET_DIRECTIONS_META = 'RESET_DIRECTIONS_META';
export const RESET_DIRECTIONS_PAGE = 'RESET_DIRECTIONS_PAGE';

// StreetViewPage - Panorama Node by ID
export const GET_STREET_VIEW_PANORAMA_NODE_BY_ID_REQUEST = 'GET_STREET_VIEW_PANORAMA_NODE_BY_ID_REQUEST';
export const GET_STREET_VIEW_PANORAMA_NODE_BY_ID_ERROR = 'GET_STREET_VIEW_PANORAMA_NODE_BY_ID_ERROR';
export const GET_STREET_VIEW_PANORAMA_NODE_BY_ID_SUCCESS = 'GET_STREET_VIEW_PANORAMA_NODE_BY_ID_SUCCESS';
export const RESET_STREET_VIEW_META = 'RESET_STREET_VIEW_META';
export const RESET_STREET_VIEW_PAGE = 'RESET_STREET_VIEW_PAGE';